module.exports = __webpack_public_path__ + "assets/b1321faf2734e0abfd8d7e23f69ac08b.ttf";